module.exports = __webpack_public_path__ + "static/media/hot-cat-banner-item-2.e11702b9.png";